import { render, staticRenderFns } from "./MoleculeEditionAcademyLegals.vue?vue&type=template&id=197f6792&"
import script from "./MoleculeEditionAcademyLegals.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyLegals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports